export default __webpack_public_path__ + "7b9a8e938c8e068ef4332d1a65bf5244.svg";